var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'oval',
  _vm.ovalPositioningClass,
  _vm.sizeMd ? 'oval-md' : '' ]},[_c('p',{staticClass:"initials-label w-100"},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }